import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-122">
      <div className="max-w-xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-124">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-125" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-126" />

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-4 relative z-10" data-id="element-127" />

          <h3 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3 relative z-10" data-id="element-128">
            Rischio zero,{' '}
            <span className="text-brand-gold" data-id="element-129">14 giorni di prova.</span>
          </h3>

          <p className="text-gray-300 text-sm sm:text-base font-medium leading-relaxed mb-5 relative z-10" data-id="element-130">
            Siamo così sicuri di Programmazione Pronta che ti diamo 14 giorni
            interi per metterlo alla prova. Se non senti che il tuo lavoro è
            diventato più veloce e organizzato, ti restituiamo ogni centesimo.
          </p>

          <div className="space-y-2 text-left max-w-sm mx-auto mb-5 relative z-10" data-id="element-131">
            {['Rimborso integrale — Senza trattenute.', 'Senza domande — Basta una email.', 'Procedura semplice — Conferma in 24 ore.'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-132">
                <CheckIcon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" strokeWidth={3} data-id="element-133" />
                <span className="text-sm text-gray-200 font-medium" data-id="element-134">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-base font-bold text-brand-cream relative z-10" data-id="element-135">
            Tu provi, noi ci assumiamo il rischio.
          </p>
        </motion.div>
      </div>
    </section>;
}